import React from 'react';

const BCIndustryFormModal = React.lazy(() => import('../components/FormModal'));
const bCIndustryModalRegistry = {
    company_bcIndustryId: BCIndustryFormModal
};
export default bCIndustryModalRegistry;
